import baseScmService from 'services/baseScmService';

const lectureBucketService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    searchLectureBucket: build.query({
      query: ({ keyword }) => ({
        method: 'GET',
        url: '/lecture-buckets/search/',
        params: { q: keyword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchLectureBucketQuery } = lectureBucketService;

export default lectureBucketService;
